import React from "react";
import { Check, Volume2, VolumeX } from "lucide-react";

export function StepBar({ steps, testid = "ged-stepbar" }) {
  const done = steps.filter((s) => s.done).length;
  return (
    <div data-testid={testid} className="space-y-2">
      <div className="flex items-center justify-between text-sm"><span className="font-semibold">Your GED roadmap</span><span className="text-white/60">{done}/5 steps</span></div>
      <div className="h-3 rounded-full bg-white/10 overflow-hidden"><div className="h-full bg-emerald-500 transition-all duration-700" style={{ width: `${done * 20}%` }} /></div>
    </div>
  );
}

export function StepList({ steps }) {
  return (
    <ol className="space-y-2" data-testid="ged-steps">
      {steps.map((s, i) => {
        const current = !s.done && steps.slice(0, i).every((x) => x.done);
        return (
          <li key={s.n} data-testid={`ged-step-${s.n}`} className={`flex items-center gap-3 rounded-xl border p-3 ${s.done ? "border-emerald-500/50 bg-emerald-500/10" : current ? "border-[#d4a017] bg-[#d4a017]/10" : "border-white/10"}`}>
            <span className={`h-9 w-9 shrink-0 grid place-items-center rounded-full font-bold ${s.done ? "bg-emerald-500 text-black" : current ? "bg-[#d4a017] text-black" : "bg-white/10 text-white/60"}`}>
              {s.done ? <Check className="h-5 w-5" /> : s.n}
            </span>
            <span className={`text-base ${s.done ? "text-white/70" : ""}`}>{s.label}</span>
          </li>
        );
      })}
    </ol>
  );
}

export function VoiceToggle({ voice }) {
  return (
    <button type="button" onClick={voice.toggle} data-testid="ged-voice-toggle" className="inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-2 text-sm">
      {voice.muted ? <VolumeX className="h-4 w-4" /> : <Volume2 className="h-4 w-4 text-[#d4a017]" />}{voice.muted ? "Voice off" : "Voice on"}
    </button>
  );
}

export function ListenBtn({ voice, k, testid }) {
  return (
    <button type="button" onClick={() => voice.play(k)} data-testid={testid || `ged-listen-${k}`} className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-2.5 text-sm font-medium">
      <Volume2 className="h-4 w-4 text-[#d4a017]" /> Listen
    </button>
  );
}
